import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { contactInfo } from '../config/contactInfo';

const PaymentCancelled = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const orderId = params.get('id') || params.get('order_id') || '-';

  const formattedDate = new Date().toLocaleString('en-US', {
    year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'
  });

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '70vh', padding: '20px' }}>
      <div style={{ maxWidth: 700, width: '100%', background: '#fff', borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,0.12)', padding: 28 }}>
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <div style={{ fontSize: 64, color: '#f57c00' }}>⟲</div>
          <h1 style={{ margin: '10px 0', fontSize: 28 }}>Payment Cancelled</h1>
          <p style={{ color: '#555' }}>You have cancelled the payment.</p>
        </div>

        <div style={{ background: '#f7f7f9', borderRadius: 8, padding: 16, margin: '20px 0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #e3e3e7' }}>
            <span style={{ fontWeight: 600 }}>Order ID:</span>
            <span>{orderId}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
            <span style={{ fontWeight: 600 }}>Date:</span>
            <span>{formattedDate}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
            <span style={{ fontWeight: 600 }}>Status:</span>
            <span style={{ color: '#f57c00', fontWeight: 700 }}>Cancelled</span>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
          <Link to="/donate" className="btn read-more-btn" style={{ textDecoration: 'none' }}>
            Try Again
          </Link>
          <Link to="/" className="btn" style={{ border: '1px solid #ddd', textDecoration: 'none' }}>
            Back to Home
          </Link>
        </div>

        <p style={{ color: '#888', fontSize: 13, marginTop: 18 }}>
          Questions? Contact us at <strong>{contactInfo.email}</strong> or call <strong>+91-{contactInfo.phone}</strong>
        </p>
      </div>
    </div>
  );
};

export default PaymentCancelled;
